export default __webpack_public_path__ + "static/media/Clinomics_Logo_EN.cf05b537.png";